module.exports = __webpack_public_path__ + "media/images/hodzzy-banner-a4dc7993731d9316d1f46cfe9b1b05a6.png";